import { render, staticRenderFns } from "./ModalAditivos.vue?vue&type=template&id=ec7bd6b4&"
import script from "./ModalAditivos.vue?vue&type=script&lang=js&"
export * from "./ModalAditivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports